import React from "react";
import type { TextProps } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

export const ProductDetailsText: React.FC<TextProps> = ({
  children,
  ...props
}) => (
  <Text display="inline" fontSize="1rem" lineHeight="1.5rem" mt={0} {...props}>
    {children}
  </Text>
);
